/* eslint no-param-reassign: "error" */
import { isWoman } from '../../utils'

export default [
  {
    id: 'mercredi',
    content: `
    Mercredi, votre collègue Louis a l’air en détresse !
    Il semble voir en vous {% if isWoman %}sa sauveuse{% else %}son sauveur{% endif %}… « J’aurais
    besoin de ton talent légendaire, toi qui sais toujours y faire avec les problèmes complexes… »

    Comment réagissez-vous ?
    `,
    choices: ['flatterie', 'santa', 'teamfirst'],
  },
  {
    id: 'flatterie',
    optionText: model => `
      Vous êtes impatient${isWoman(model) ? 'e' : ''}
    de découvrir ce dont il a besoin ! C’est toujours
    valorisant d’être sollicité${isWoman(model) ? 'e' : ''} par ses pairs.
    `,
    content: `
    Quand un membre de votre équipe est en difficulté, vous venez à sa rescousse ! Attention
    toutefois à prendre le temps de réfléchir à votre réaction : est-ce bien possible à concilier
    dans votre agenda ? Y a-t-il un risque que vous ayez dit oui par peur de le vexer ?
    Cela pourrait renvoyer aux fameux pilotes clandestins, notamment le fameux “fais plaisir aux autres”.
    Soyez vigilant{% if isWoman %}e{% endif %} :)

    Louis ne sait plus comment effectuer la revue qualité des projets, il aimerait un rappel assez détaillé,
    car il a peur de mal faire. Que répondez-vous à sa demande ?
    `,
    choices: ['documentation', 'occasion', 'deleguer'],
  },
  {
    id: 'documentation',
    optionText: `Vous lui envoyez la documentation et lui rappelez que vous avez suivi la même
    formation le mois dernier, il devrait s’en sortir !`,
    content: `
    Cette réponse expéditive déçoit un peu Louis. Dans les faits, vous êtes dans le vrai car vous avez bien
    en tête vos priorités et votre organisation. Maintenir son cap face aux sollicitations extérieures n’est pas
    facile, mais c’est de cette façon que vous donnerez réellement de la valeur à votre temps, pour vous-même et
    pour vos collègues.

    L’encourager est une bonne idée. Cela devrait l’aider à gagner confiance en lui et à se motiver.
    [Découvrir la fin de la semaine](@vendredi)
    `,
  },
  {
    id: 'occasion',
    optionText: `Vous aimez bien passer du temps à échanger avec vos collègues, vous trouvez que l’occasion
    est trop belle pour pinailler.`,
    content: `
    Attention ! Vous n’avez même pas réfléchi au temps que cela vous prendrait… ni au degré de priorité de sa
    demande ? Et enfin, êtes-vous bien la bonne personne pour répondre à cette demande ? Il y a peut-être
    des alternatives :)

    En plus, au fond de vous, vous savez que Louis est du genre bavard… Les heures sup’ se rapprochent !
    [Découvrir la fin de la semaine](@vendredi)
    `,
  },
  {
    id: 'deleguer',
    optionText: `Vous lui proposez de vous inviter à un point d’une heure en fin de journée. En contrepartie,
    vous lui déléguez la revue de votre projet, l’invitant à s’entraîner avec un deuxième cas pratique !`,
    content: `
    Alors ça, c’est du grand art ! Vous consacrez effectivement du temps à Louis et vous balisez le
    terrain. Fixer un créneau, c’est maîtriser votre temps comme un{% if isWoman %}e{% endif %} chef. Cerise sur le gâteau,
    le retour sur investissement de ce temps passé est total puisque vous lui confiez une tâche… qui vous
    aurait pris une heure. Bravo !
    [Découvrir la fin de la semaine](@vendredi)
    `,
  },
  {
    id: 'santa',
    optionText: model => `Je ne savais pas que j’étais ${isWoman(model) ? 'la Mère Noël' : 'le Père Noël'}…
    Je le sens mal !`,
    content: `
    Vous avez dû penser tout haut, Louis se ravise et se souvient qu’il peut retrouver la procédure
    dans un document exhaustif. Il est un peu déçu sur le coup, mais en étant clair, factuel et
    bienveillant, Louis comprend et ne vous en tient pas rigueur. Au contraire, vous l’aidez ainsi à
    prendre également du recul sur ses pratiques. Attention quand même à ne pas systématiquement rejeter
    une demande avant même de l’avoir clarifiée.
    [Découvrir la fin de la semaine](@vendredi)
    `,
  },
  {
    id: 'teamfirst',
    optionText: `Il faut voir, ça peut bénéficier à l’équipe !`,
    content: `
    Vous avez le réflexe de solliciter le manager d’équipe, qui passait justement par-là. Louis vous explique
    alors qu’il ne sait plus comment effectuer la revue qualité des projets. Il demande donc un rappel assez détaillé,
    car il a peur de mal faire. Votre manager vous remercie d’avoir eu le réflexe de partager le problème,
    et vous invite à choisir la meilleure manière de gérer cette demande. Comment réagissez-vous ?
    `,
    choices: ['revue', 'envoi', 'parole'],
  },
  {
    id: 'revue',
    optionText: `Vous proposez d’évoquer les points qui ne sont pas clairs dans un point d’une demi-heure pour
    que chacun partage le même niveau d’information.`,
    content: `
    30 minutes, c’est un bon créneau pour balayer les points essentiels. Assurez-vous que les participants
    puissent préparer la réunion, sinon vous risquez de perdre votre temps et Louis reviendra vers vous le mois
    suivant à coup sûr ! Rappelez-vous, cela implique de bien vous organiser : bloquer le créneau dans l’agenda
    des participants, définir clairement les objectifs du point, s’assurer que tout le monde vienne
    préparé...et bien sûr, s’assurer que le point ne dépasse pas les 30 minutes !
    [Découvrir la fin de la semaine](@vendredi)
    `,
  },
  {
    id: 'envoi',
    optionText: `Vous suggérez d’envoyer à Louis les documents sur lesquels vous vous basez pour
    faire vos revues.`,
    content: `
    Louis risque encore d’avoir des questions et de vous déranger de la même manière dans la semaine… Vous n’êtes
    pas sorti{% if isWoman %}e{% endif %} d’affaire !
    [Découvrir la fin de la semaine](@vendredi)
    `,
  },
  {
    id: 'parole',
    optionText: `Vous donnez la parole à Louis, après tout, c’est lui qui est en demande !`,
    content: `
    Vous ne vous mouillez pas dans l’affaire, alors que Louis en exprime le besoin. Si vous étiez force de
    proposition, vous pourriez mieux le guider : il peut n’avoir aucune idée de la manière de traiter
    son problème, et sécher face à cette question.
    [Découvrir la fin de la semaine](@vendredi)
    `,
  },
]
